export default __webpack_public_path__ + "static/media/2018 (3).54afd380.JPG";